var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInsignia = function SvgInsignia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 238.04 615.82",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "27.07 333.16 57.99 364.07 88.85 333.21 88.85 355.27 58.8 385.32 27.31 353.83 27.07 333.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.44 333.16 179.35 364.07 210.21 333.21 210.21 355.27 180.16 385.32 148.67 353.83 148.44 333.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.28 299.93 119.37 269.01 88.5 299.88 88.5 277.81 118.56 247.76 150.05 279.25 150.28 299.93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.11,225.94V365.7h15.2V234.11A126.71,126.71,0,0,1,51.11,225.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.92,225.94V365.7H171.73V234.11A125.83,125.83,0,0,0,186.92,225.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39,371.93q3.45,0,6.85.18V267.38H111.05V372.21C113.81,372,116.59,371.93,119.39,371.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 119.39,
    cy: 497.18,
    r: 118.64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.64,
    cy: 118.64,
    r: 118.64
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInsignia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/insignia.3b2a7159.svg";
export { ForwardRef as ReactComponent };